import { ApolloProvider } from '@apollo/client/react';
import { type ReactNode, useState } from 'react';

import { GRAPHQL_ENDPOINT_URL } from '@/apollo/constants/GraphqlEndpointUrl';
import { useApolloErrorHandlers } from '@/apollo/hooks/useApolloErrorHandlers';
import { createApolloClient } from '@/apollo/utils/createApolloClient';

type AppApolloProviderProps = {
  // The sign-in seam: Clerk's getToken() with Clerk sign-in, or a function
  // that returns null with the server's mock sign-in (AppAuthProvider).
  getAuthToken: () => Promise<string | null>;
  children: ReactNode;
};

export const AppApolloProvider = ({
  getAuthToken,
  children,
}: AppApolloProviderProps) => {
  const { handleUnauthenticated, handleUnexpectedError } =
    useApolloErrorHandlers();
  // Created once, so the cache lives as long as the app.
  const [apolloClient] = useState(() =>
    createApolloClient({
      uri: GRAPHQL_ENDPOINT_URL,
      getAuthToken,
      onUnauthenticated: handleUnauthenticated,
      onUnexpectedError: handleUnexpectedError,
    }),
  );

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
